import React, { useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import { deleteAccount } from '../lib/accountDeleteService';

export function DeleteAccountButton({ className, label = "Delete Account" }) {
  const [loading, setLoading] = useState(false);

  const handleDeleteAccount = async () => {
    if (!confirm("Delete your OpenPath account and all associated data?")) return;
    setLoading(true);
    try {
      await deleteAccount();
      await signOut();
    } catch (err) {
      alert(err instanceof Error ? err.message : "Delete failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button onClick={handleDeleteAccount} disabled={loading} className={className}>
      {loading ? "Deleting…" : label}
    </button>
  );
}